var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 8.6999L4.4999 12.1999C4.3999 12.2999 4.28324 12.3499 4.1499 12.3499C4.01657 12.3499 3.8999 12.2999 3.7999 12.1999C3.6999 12.0999 3.6499 11.9832 3.6499 11.8499C3.6499 11.7166 3.6999 11.5999 3.7999 11.4999L7.2999 7.9999L3.7999 4.4999C3.6999 4.3999 3.6499 4.28324 3.6499 4.1499C3.6499 4.01657 3.6999 3.8999 3.7999 3.7999C3.8999 3.6999 4.01657 3.6499 4.1499 3.6499C4.28324 3.6499 4.3999 3.6999 4.4999 3.7999L7.9999 7.2999L11.4999 3.7999C11.5999 3.6999 11.7166 3.6499 11.8499 3.6499C11.9832 3.6499 12.0999 3.6999 12.1999 3.7999C12.2999 3.8999 12.3499 4.01657 12.3499 4.1499C12.3499 4.28324 12.2999 4.3999 12.1999 4.4999L8.6999 7.9999L12.1999 11.4999C12.2999 11.5999 12.3499 11.7166 12.3499 11.8499C12.3499 11.9832 12.2999 12.0999 12.1999 12.1999C12.0999 12.2999 11.9832 12.3499 11.8499 12.3499C11.7166 12.3499 11.5999 12.2999 11.4999 12.1999L7.9999 8.6999Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/closeGray.ef976bc8.svg";
export { ForwardRef as ReactComponent };